module.exports = __webpack_public_path__ + "static/media/spatula.7ddc5739.svg";